module.exports = __webpack_public_path__ + "img/magazine02.a01949cf.jpg";